import { OrganizationsState } from '../../../organizations/OrganizationsState';
import { INoteTemplate } from './TemplatesConfig';


const templates: INoteTemplate[] = [
    {
        templateId: 'org-general-part-1',
        body: `
Maiden Name


Spouse / Partner’s Name


Home Address


Second Address


Email Address


Email Password


Date of Death


Social Security Number


Driver’s License Number / Issuing State

        `,
        label: 'General Info - Care Recipient',
        useLabelForTitle: true,
        focusLocation: 12,
        target: { section: 'patient' }
    },
    {
        templateId: 'org-general-part-2',
        target: { section: 'patient' },
        label: 'General Info - Part 2 - Care Recipient',
        useLabelForTitle: true,
        focusLocation: 11,
        body: `
Occupation

POA Name / Phone Number / Email


Guardian Name / Phone Number / Email


Health Surrogate Name / Phone Number / Email


Home Phone Number


Cell Phone Number and Passcode


Place of Birth


Citizenship Country


Mother’s Name (and Maiden Name)


Father’s Name


Religious Affiliation
        `
    },
    {
        templateId: 'org-home',
        target: { section: 'patient' },
        label: 'Home Information',
        useLabelForTitle: true,
        focusLocation: 11,
        body: `
Alarm Code

Garage Code

Gate Code

Spare Key / Codes

        `
    },
    {
        templateId: 'org-next-of-kin',
        target: { section: 'patient' },
        label: 'Next of Kin',
        useLabelForTitle: true,
        focusLocation: 19,
        body: `
Name, Relationship

Address

Phone Number(s)

Email Address

Notes

--------------------------
Name, Relationship

Address

Phone Number(s)

Email Address

Notes


--------------------------
Name, Relationship

Address

Phone Number(s)

Email Address

Notes

        `
    }
];

export class CustomOrgTemplates {
    static inject = () => [OrganizationsState];
    constructor(private orgs: OrganizationsState){

    }
    getTemplates = (): INoteTemplate[] => {
        if (this.orgs.isOrgTeamMember()){
            // TODO: org specific...
            return templates;
        }
        return [];
    };
};
